export const API_URL = `https://forkify-api.herokuapp.com/api/v2/recipes/`;
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = `37cbc6ea-6cc0-4098-8117-1efe215a4288`;
export const MODAL_CLOSE_SEC = 2.5;
